import { isFunction, isNil } from "lodash";
import {
  API_SURVEYS,
  HTTP_STATUS_UNAUTHORIZED,
  SERVER_HOST,
} from "../../../util/Constants";

// Convertir BASE_SURVEYS_URL en una función para que se evalúe en tiempo de ejecución
export const getBaseSurveysUrl = () => {
  const host = SERVER_HOST();
  const apiPath = API_SURVEYS;

  // If host ends with slash and apiPath starts with slash, remove one slash
  if (host.endsWith("/") && apiPath.startsWith("/")) {
    return `${host}${apiPath.substring(1)}`;
  }

  // If host doesn't end with slash and apiPath doesn't start with slash, add slash
  if (!host.endsWith("/") && !apiPath.startsWith("/")) {
    return `${host}/${apiPath}`;
  }

  // Normal case - either host ends with slash or apiPath starts with slash
  return `${host}${apiPath}`;
};

export const handleApiResponse = async (response, logout) => {
  const status = response?.status;
  const json = await response.json();

  if (
    status === HTTP_STATUS_UNAUTHORIZED &&
    !isNil(logout) &&
    isFunction(logout)
  ) {
    logout(true);
  }

  if (json.ok) {
    return {
      ok: true,
      data: json.dataResponse,
      error: null,
    };
  } else {
    return {
      ok: false,
      data: null,
      error: json.errorMsg || null,
    };
  }
};
